import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LeaveTypeComponent } from './leave-type.component';
import { LeaveTypesDetailsComponent } from './components/leave-types-details/leave-types-details.component';
import { LeaveTypesCreateComponent } from './components/leave-types-create/leave-types-create.component';

const routes: Routes = [
  {
    path: '', component:LeaveTypeComponent,children:[
       {
         path:'',component: LeaveTypesDetailsComponent
       },
       {
        path:'details',component: LeaveTypesDetailsComponent
       },
       {
         path: ':id',component:LeaveTypesCreateComponent
       } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeaveTypeRoutingModule { }
